"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLDER_ID = exports.ECOMM_STORE_ID = exports.ECOMM_APP_ID = exports.ECOMM_SYNCED = void 0;
var ECOMM_SYNCED = 'ip__ecomm_bridge__ecomm_synced';
exports.ECOMM_SYNCED = ECOMM_SYNCED;
var ECOMM_APP_ID = 'ip__ecomm_bridge__source_app_id';
exports.ECOMM_APP_ID = ECOMM_APP_ID;
var ECOMM_STORE_ID = 'ip__ecomm_bridge__source_store_id';
exports.ECOMM_STORE_ID = ECOMM_STORE_ID;
var FOLDER_ID = 'hs_folder_id';
exports.FOLDER_ID = FOLDER_ID;